class AkkermansiaWorks extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
    this._initialized = false;
    this._handleSectionLoad = this._handleSectionLoad.bind(this);
    this._handleSectionUnload = this._handleSectionUnload.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;
    document.addEventListener("shopify:section:load", this._handleSectionLoad);
    document.addEventListener("shopify:section:unload", this._handleSectionUnload);
    this._initDeferredMedia();
  }

  disconnectedCallback() {
    this._initialized = false;
    this._destroyObserver();
    document.removeEventListener("shopify:section:load", this._handleSectionLoad);
    document.removeEventListener("shopify:section:unload", this._handleSectionUnload);
  }

  _isOurSection(event) {
    const section = this.closest(".shopify-section");
    return section && (event.target === section || section.contains(event.target));
  }

  _handleSectionLoad(event) {
    if (!this._isOurSection(event)) return;
    this._destroyObserver();
    this._initDeferredMedia();
  }

  _handleSectionUnload(event) {
    if (!this._isOurSection(event)) return;
    this._destroyObserver();
  }

  _shouldDefer() {
    return this.dataset.deferVideo === "true";
  }

  _loadIframe(iframe) {
    const deferredSrc = iframe.dataset.awDeferSrc;
    if (!deferredSrc || iframe.src) return;
    iframe.src = deferredSrc;
    iframe.removeAttribute("data-aw-defer-src");
  }

  _loadNativeVideo(video) {
    const source = video.querySelector("source[data-aw-defer-src]");
    if (source && !source.getAttribute("src")) {
      source.setAttribute("src", source.dataset.awDeferSrc);
      source.removeAttribute("data-aw-defer-src");
    }
    video.load();
    if (video.autoplay) {
      video.play().catch(() => {});
    }
  }

  _activateTarget(target) {
    if (target.matches("iframe[data-aw-defer-src]")) {
      this._loadIframe(target);
      return;
    }

    if (target.matches("video[data-aw-defer-native]")) {
      this._loadNativeVideo(target);
    }
  }

  _initDeferredMedia() {
    if (!this._shouldDefer()) return;

    const targets = this.querySelectorAll(
      "iframe[data-aw-defer-src], video[data-aw-defer-native]",
    );
    if (targets.length === 0) return;

    this._destroyObserver();

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this._activateTarget(entry.target);
          this._observer?.unobserve(entry.target);
        });
      },
      { rootMargin: "200px 0px", threshold: 0.1 },
    );

    targets.forEach((target) => this._observer.observe(target));
  }

  _destroyObserver() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }
}

if (!customElements.get("akkermansia-works")) {
  customElements.define("akkermansia-works", AkkermansiaWorks);
}
